import { StatusBadge, type StatusTone } from "@/shared/status/status-badge";

export const APPOINTMENT_STATUS_LABELS: Record<string, string> = {
  proposed: "Hold",
  pending: "Pending",
  booked: "Booked",
  arrived: "Checked In",
  "checked-in": "Checked In",
  checkedIn: "Checked In",
  inProgress: "In progress",
  "in-progress": "In progress",
  completed: "Completed",
  fulfilled: "Completed",
  noshow: "No Show",
  noShow: "No Show",
  cancelled: "Cancelled",
};

const STATUS_TONES: Record<string, StatusTone> = {
  proposed: "idle",
  pending: "idle",
  booked: "idle",
  arrived: "attention",
  "checked-in": "attention",
  checkedIn: "attention",
  inProgress: "open",
  "in-progress": "open",
  completed: "done",
  fulfilled: "done",
  noShow: "attention",
  noshow: "attention",
  cancelled: "idle",
};

/**
 * A STANDALONE status badge, where a hue stating the status is correct.
 *
 * Inside an accent-tinted timeline block it is not: the card already carries
 * status as its variant, and a second hue there reads as a second identity.
 * Those places render `TimelineBlock.Label` with APPOINTMENT_STATUS_LABELS.
 */
export function AppointmentStatusBadge({ status }: { status: string }) {
  const label = APPOINTMENT_STATUS_LABELS[status] ?? status;

  return <StatusBadge tone={STATUS_TONES[status] ?? "idle"}>{label}</StatusBadge>;
}
